import { render, staticRenderFns } from "./settings-menu.vue?vue&type=template&id=4623cfa4&"
import script from "./settings-menu.vue?vue&type=script&lang=ts&setup=true&"
export * from "./settings-menu.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports